import React from 'react';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isRequired } from '../../../utils/validation';

const OldAddSignatoryCountryOfResidence = ({ values }) => (
  <Content>
    {({
      countryOfResidence,
      ncountryResidenceDefault,
      otherLabel,
      globalRadioError,
      defaultCountryCode
    }) => (
      <Field
        name="country_of_residence"
        subscription={{ touched: true, error: true }}
        validate={isRequired}
      >
        {({ meta: { touched, error }, input }) => (
          <GenericFieldWrapper
            name="country_of_residence"
            title={countryOfResidence}
            validationMessage={touched && !!error ? globalRadioError : null}
          >
            <GenericRadio.InlineSet
              groupName="country_of_residence"
              items={[
                {
                  id: defaultCountryCode,
                  labelText: ncountryResidenceDefault
                },
                {
                  id: otherLabel,
                  labelText: otherLabel
                }
              ]}
              {...input}
              selectedId={values.country_of_residence}
            />
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default OldAddSignatoryCountryOfResidence;
